// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ap-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
}

.ap-header h2 {
  font-size: 24px;
  font-weight: bold;
  color: #222;
  margin: 0;
}

.ap-back {
  background: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  color: #555;
  transition: all 0.2s;
}
.ap-back:hover { background: #f5f5f5; }

.ap-form {
  background: #fff;
  border-radius: 10px;
  padding: 32px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.06);
  max-width: 820px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ap-error {
  background: #fde8e8;
  color: #c81e1e;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
}

.ap-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.ap-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ap-field label,
.ap-section > label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}

.ap-checkbox-field label {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.ap-checkbox-field input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: none;
  padding: 0;
  background: none;
  flex-shrink: 0;
}

.ap-field input,
.ap-field select,
.ap-field textarea {
  border: 1px solid #ddd;
  border-radius: 7px;
  padding: 11px 13px;
  font-size: 14px;
  color: #222;
  background: #fafafa;
  outline: none;
  transition: border-color 0.2s;
  font-family: inherit;
  resize: vertical;
}

.ap-field input:focus,
.ap-field select:focus,
.ap-field textarea:focus {
  border-color: #222e3c;
  background: #fff;
}

.ap-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ap-feature-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.ap-feature-row input {
  flex: 1 1;
  border: 1px solid #ddd;
  border-radius: 7px;
  padding: 10px 13px;
  font-size: 14px;
  color: #222;
  background: #fafafa;
  outline: none;
  font-family: inherit;
}
.ap-feature-row input:focus { border-color: #222e3c; background: #fff; }

.ap-feature-remove {
  background: #fde8e8;
  border: none;
  border-radius: 6px;
  width: 34px;
  height: 34px;
  cursor: pointer;
  color: #c81e1e;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ap-feature-remove:hover { background: #fbd5d5; }

.ap-feature-add {
  align-self: flex-start;
  background: none;
  border: 1px dashed #aaa;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
}
.ap-feature-add:hover { border-color: #555; color: #222; }

.ap-image-upload-area {
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 28px;
  text-align: center;
  cursor: pointer;
  color: #888;
  font-size: 14px;
  transition: border-color 0.2s, background 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.ap-image-upload-area:hover { border-color: #222e3c; background: #f8f9ff; color: #222e3c; }

.ap-upload-icon { font-size: 32px; }

.ap-upload-hint {
  font-size: 12px;
  color: #aaa;
}

.ap-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
}

.ap-preview-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: visible;
}

.ap-preview-item img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #eee;
}

.ap-preview-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #c81e1e;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 11px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ap-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  border-top: 1px solid #eee;
  padding-top: 20px;
  margin-top: 4px;
}

.ap-btn-cancel {
  padding: 12px 24px;
  background: none;
  border: 1px solid #ddd;
  border-radius: 7px;
  font-size: 14px;
  cursor: pointer;
  color: #555;
}
.ap-btn-cancel:hover { background: #f5f5f5; }

.ap-btn-save {
  padding: 12px 28px;
  background: #222e3c;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.ap-btn-save:hover { background: #1a2230; }
.ap-btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
`, "",{"version":3,"sources":["webpack://./src/pages/AddProduct.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;AACA,8BAA8B,qBAAqB,EAAE,gBAAgB,EAAE;;AAEvE;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA,wBAAwB,kBAAkB,EAAE,WAAW,EAAE;;AAEzD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE1F,kBAAkB,eAAe,EAAE;;AAEnC;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,YAAY,EAAE,mBAAmB,EAAE","sourcesContent":[".ap-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\n.ap-header h2 {\n  font-size: 24px;\n  font-weight: bold;\n  color: #222;\n  margin: 0;\n}\n\n.ap-back {\n  background: none;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 8px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #555;\n  transition: all 0.2s;\n}\n.ap-back:hover { background: #f5f5f5; }\n\n.ap-form {\n  background: #fff;\n  border-radius: 10px;\n  padding: 32px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.06);\n  max-width: 820px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ap-error {\n  background: #fde8e8;\n  color: #c81e1e;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: 14px;\n}\n\n.ap-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.ap-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ap-field label,\n.ap-section > label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n}\n\n.ap-checkbox-field label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.ap-checkbox-field input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  border: none;\n  padding: 0;\n  background: none;\n  flex-shrink: 0;\n}\n\n.ap-field input,\n.ap-field select,\n.ap-field textarea {\n  border: 1px solid #ddd;\n  border-radius: 7px;\n  padding: 11px 13px;\n  font-size: 14px;\n  color: #222;\n  background: #fafafa;\n  outline: none;\n  transition: border-color 0.2s;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.ap-field input:focus,\n.ap-field select:focus,\n.ap-field textarea:focus {\n  border-color: #222e3c;\n  background: #fff;\n}\n\n.ap-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ap-feature-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.ap-feature-row input {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 7px;\n  padding: 10px 13px;\n  font-size: 14px;\n  color: #222;\n  background: #fafafa;\n  outline: none;\n  font-family: inherit;\n}\n.ap-feature-row input:focus { border-color: #222e3c; background: #fff; }\n\n.ap-feature-remove {\n  background: #fde8e8;\n  border: none;\n  border-radius: 6px;\n  width: 34px;\n  height: 34px;\n  cursor: pointer;\n  color: #c81e1e;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ap-feature-remove:hover { background: #fbd5d5; }\n\n.ap-feature-add {\n  align-self: flex-start;\n  background: none;\n  border: 1px dashed #aaa;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  color: #555;\n  cursor: pointer;\n}\n.ap-feature-add:hover { border-color: #555; color: #222; }\n\n.ap-image-upload-area {\n  border: 2px dashed #ccc;\n  border-radius: 10px;\n  padding: 28px;\n  text-align: center;\n  cursor: pointer;\n  color: #888;\n  font-size: 14px;\n  transition: border-color 0.2s, background 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.ap-image-upload-area:hover { border-color: #222e3c; background: #f8f9ff; color: #222e3c; }\n\n.ap-upload-icon { font-size: 32px; }\n\n.ap-upload-hint {\n  font-size: 12px;\n  color: #aaa;\n}\n\n.ap-previews {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.ap-preview-item {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  overflow: visible;\n}\n\n.ap-preview-item img {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.ap-preview-remove {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: #c81e1e;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  font-size: 11px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ap-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  border-top: 1px solid #eee;\n  padding-top: 20px;\n  margin-top: 4px;\n}\n\n.ap-btn-cancel {\n  padding: 12px 24px;\n  background: none;\n  border: 1px solid #ddd;\n  border-radius: 7px;\n  font-size: 14px;\n  cursor: pointer;\n  color: #555;\n}\n.ap-btn-cancel:hover { background: #f5f5f5; }\n\n.ap-btn-save {\n  padding: 12px 28px;\n  background: #222e3c;\n  color: #fff;\n  border: none;\n  border-radius: 7px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.ap-btn-save:hover { background: #1a2230; }\n.ap-btn-save:disabled { opacity: 0.6; cursor: not-allowed; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
